import React from 'react';

import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import GrayPanel from '../../../components/GrayPanel/GrayPanel';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import termsOfUseDefaultContent from '../../../components/utils/termsOfUse/constants';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import SimpleTextEditor from '../../../components/utils/SimpleTextEditor/SimpleTextEditor';
import ModalAlert from '../../eservices/ModalAlert';
import waiting from '../../paymentStatus/waiting-wheel-300x300.gif';  
import ReactDOMServer from 'react-dom/server';
import styles from './TermsOfUseEditor.css';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const bodyStyle = {
  textAlign: 'center',
  marginTop: '100px',
  marginBottom: '100px'
};


class TermsOfUseEditor extends React.Component {
    state = {
        content: null,
        defaultContent: null,
        isMounted: false,
        saveSuccess: false,
        dataChanged: false,
        colors: 'normal',
        sourceStyle: layoutColorStyle,
        style: {},
        errorTitle: '',
        errorText: '',
        showError: false
        
    }

    ignoreNextEditorChange = true;

    async componentDidMount() {
        const colors = getThemeFromLocalStorage();
        let sourceStyle = layoutColorStyle;

        let style = {
            color: sourceStyle[colors].color,
            display: 'block',
        };

        if (colors !== 'normal') {
            sourceStyle = headerStyle;
            style = {
            color: sourceStyle[colors].color,
            backgroundColor: sourceStyle[colors].backgroundColor,
            display: 'block',
            };
        }

        this.setState({ colors, sourceStyle, style });

        const url = `${process.env.API_URL}/eservices/html_files?type=termsOfUse`;

        await fetch(url, {
            method: 'GET',
        })
        .then((response) => {
            if (response.status == 200) {
                return response.json();
            } else {
                throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
            }
        })
        .then((data) => {
            if (!data || !data.find(item => item.type === 'termsOfUse')) {
                const defaultHtml = ReactDOMServer.renderToStaticMarkup(termsOfUseDefaultContent);
                this.setState({ content: defaultHtml, defaultContent: defaultHtml, isMounted: true });
            } else {
                const fetchedHtml = data.find(item => item.type === 'termsOfUse').html;
                this.setState({ content: fetchedHtml, defaultContent: fetchedHtml, isMounted: true });
            }
        })
        .catch((error) => {
            console.error('Error fetching HTML content:', error);
        });
    }

    confirmModal = () => {
        return (
            <div className={styles.declarationModal}>
                <div className={styles.declarationModal__container} style={this.state.style}>
                <div className={styles.declarationModal__header}>Czy na pewno chcesz zapisać zmiany?</div>
                <div className={styles.modalButtons}>
                    <button onClick={this.showModalAlert} className="btn btn-primary">Anuluj</button>
                    <button onClick={this.sendNewData} className={`btn btn-success ${styles.modalButtons__right}`}>Zapisz</button>
                </div>
                </div>
            </div>
        );
    }

    showModalAlert = () => {
        this.setState({
            showModal: !this.state.showModal,
        });
    }

    cancelChanges = () => {
        this.ignoreNextEditorChange = true;
        this.setState({
            content: this.state.defaultContent,
            dataChanged: false,
        });
    }

    handleEditorChange = (html) => {
        if (this.ignoreNextEditorChange) {
            return this.ignoreNextEditorChange = false;
        }

        this.setState({
            content: html,
            dataChanged: html !== this.state.defaultContent,
        });
    };

    onHide = () => this.setState({ showError: false }, () => {
        if (this.state.saveSuccess) {
            window.location.reload();
        }
    });

    sendNewData = () => {
        const data = JSON.stringify(
            {
                type: 'termsOfUse',
                html: this.state.content,
                user_id: this.props.user ? this.props.user.userId : null,
            }
        );

        const successMessage = 'Zmiany zostały zapisane. Wymagane jest odświeżenie strony.';
        const failureMessage = 'Wystąpił błąd przy zapisie zmian.';

        fetch(`${process.env.API_URL}/eservices/html_files/save`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: data,
            },
        )
        .then((response) => {
            if (response.status === 200) {
                this.setState({
                    errorText: successMessage,
                    errorTitle: 'Zmiany zapisane.',
                    showError: true,
                    saveSuccess: true,
                });
            } else {
                this.setState({
                    errorText: failureMessage,
                    errorTitle: 'Błąd przy zapisywaniu zmian.',
                    showError: true,
                    saveSuccess: false,
                });
            }
        })
        .catch((error) => {
            this.setState({
                errorText: failureMessage,
                errorTitle: 'Błąd przy zapisywaniu zmian.',
                showError: true,
            });
        });
    }

    render() {
        if (!this.state.isMounted) {
            return (
                <GrayPanel
                    title="Trwa ładowanie zawartości..."
                    bodyStyle={bodyStyle}
                    >
                    <img alt="Loader" src={waiting} />
                </GrayPanel>
            )
        }

        return (
            <div style={{ paddingTop: '20px' }}>
                <style>
                {`
                    .btn disabled, .btn[disabled] {
                    opacity: 1;
                    }
                `}
                </style>

                <PaperHeader title="Regulamin portalu" text="" />

                <GrayPanel
                    title={'Regulamin portalu - edycja'}
                >
                <SimpleTextEditor
                    value={this.state.content}
                    onChange={this.handleEditorChange}
                />
                </GrayPanel>

                {/* BUTTONS */}
                <div className="row mobile-row">
                    <div className="col-sm-12">
                        <button
                            type="submit-lg"
                            className="btn btn-success"
                            style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                            onClick={() => this.showModalAlert()}
                            disabled={!this.state.dataChanged}
                        >
                            Zapisz zmiany
                        </button>
                        <button
                            type="submit-lg"
                            className="btn btn-primary"
                            style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                            onClick={() => this.cancelChanges()}
                            disabled={!this.state.dataChanged}
                        >
                            Anuluj zmiany
                        </button>
                    </div>
                </div>
                {this.state.showModal && this.confirmModal()}
                <ModalAlert
                    title={this.state.errorTitle}
                    bodyText={this.state.errorText}
                    show={this.state.showError}
                    name="errorModal"
                    onHide={this.onHide}
                />
            </div>  
        );
    }
}

export default withStyles(styles)(TermsOfUseEditor);



// WEBPACK FOOTER //
// src/routes/admin/terms_of_use_editor/TermsOfUseEditor.js